import { OrderDirection } from '@enums/index';
import { showToast } from '@slices/apiSlice';
import { baseApi } from '@store/baseQuery';


import { MenteePlans, MenteePlansFilters } from '../types';

export const billings = baseApi.injectEndpoints({
    endpoints: builder => ({
        getMeteePlans: builder.query<MenteePlans, MenteePlansFilters>({
            query: ({ offset, limit, orderBy, orderDirection, status, fromDate, toDate }) => ({
                url: `/mentee/plan`,
                method: 'GET',
                params: {
                    offset: offset ?? 0,
                    limit: limit ?? 10,
                    orderBy: orderBy ?? 'createdAt',
                    orderDirection: orderDirection ?? OrderDirection.Desc,
                    status,
                    fromDate,
                    toDate,
                } as MenteePlansFilters,
            }),
            providesTags: ['MenteePlans'],
            async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
    }),
    overrideExisting: true,
});

export const { useGetMeteePlansQuery, useLazyGetMeteePlansQuery } = billings;
